import {
  GETTAXRETURNTYPEMASTER,
  CREATETAXRETURNTYPEMASTER,
  UPDATETAXRETURNTYPEMASTER,
  DELETETAXRETURNTYPEMASTER,
  GETTAXTDSSECTIONMASTER,
  CREATETAXTDSSECTIONMASTER,
  UPDATETAXTDSSECTIONMASTER,
  DELETETAXTDSSECTIONMASTER,
  GETTAXTCSSECTIONMASTER,
  CREATETAXTCSSECTIONMASTER,
  UPDATETAXTCSSECTIONMASTER,
  DELETETAXTCSSECTIONMASTER,
  GETTAXMASTER,
  CREATETAXMASTER,
  UPDATETAXMASTER,
  DELETETAXMASTER,

  CREATEPRODUCT,
  CREATEPRODUCTGROUP,
  DELETEPRODUCT,
  DELETEPRODUCTGROUP,
  GETPRODUCT,
  GETPRODUCTGROUP,
  UPDATEPRODUCT,
  UPDATEPRODUCTGROUP,
  GETSPECIFICATION,
  CREATESPECIFICATION,
  UPDATESPECIFICATION,
  DELETESPECIFICATION,
  GETPROMOCODE,
  CREATEPROMOCODE,
  UPDATEPROMOCODE,
  DELETEPROMOCODE,
  GETPPRODUCTPACKAGE,
  CREATEPPRODUCTPACKAGE,
  UPDATEPPRODUCTPACKAGE,
  DELETEPPRODUCTPACKAGE,
  GETPPRODUCTTAX,
  CREATEPPRODUCTTAX,
  UPDATEPPRODUCTTAX,
  DELETEPPRODUCTTAX,
  GETPPRODUCTTAXTYPE,
  CREATEPPRODUCTTAXTYPE,
  UPDATEPPRODUCTTAXTYPE,
  DELETEPPRODUCTTAXTYPE,
  VERIFY_AND_SAVE_PAYMENT,
  GETSPECIFICATIONTYPE,
  CREATESPECIFICATIONTYPE,
  UPDATESPECIFICATIONTYPE,
  DELETESPECIFICATIONTYPE,
  GETTRANSACTIONINFORMATION,
  GETSPECIALIZATION,
  CREATESPECIALIZATION,
  UPDATESPECIALIZATION,
  DELETESPECIALIZATION,
  GETPRODUCTSETUPDEPARTMENT,
  CREATEPRODUCTSETUPDEPARTMENT,
  UPDATEPRODUCTSETUPDEPARTMENT,
  DELETEPRODUCTSETUPDEPARTMENT,
  GETPRODUCTSETUPROLE,
  CREATEPRODUCTSETUPROLE,
  UPDATEPRODUCTSETUPROLE,
  DELETEPRODUCTSETUPROLE,
  GETPRODUCTSETUPROLETYPE,
  CREATEPRODUCTSETUPROLETYPE,
  UPDATEPRODUCTSETUPROLETYPE,
  DELETEPRODUCTSETUPROLETYPE,
  CREATEDURATION,
  GETDURATION,
  DELETEDURATION,
  UPDATEDURATION,
  GETPAYMENTMODE,
  CREATEPAYMENTMODE,
  UPDATEPAYMENTMODE,
  DELETEPAYMENTMODE,
  CREATEPRODUCTSPECIALITY,
  GETPRODUCTSPECIALITY,
  UPDATEPRODUCTSPECIALITY,
  DELETEPRODUCTSPECIALITY,
  CREATEPRODUCTLANGUAGE,
  GETPRODUCTLANGUAGE,
  UPDATEPRODUCTLANGUAGE,
  DELETEPRODUCTLANGUAGE,
  CREATEPRODUCTCURRENCY,
  GETPRODUCTCURRENCY,
  UPDATEPRODUCTCURRENCY,
  DELETEPRODUCTCURRENCY,
} from "../actions/types";

const initialState = {
  productgroupList: [],
  productList: [],
  SpecificationList: [],
  SpecificationTypeList: [],
  PromocodeList: [],
  ProductPackageList: [],
  ProductTaxTypeList: [],
  setupProductDurationList: [],
  productLanguageList: [],
  productCurrencyList: [],
  productSalesChannelList: [],
  productSalesPartyTypeList: [],
  productCommissionModelList: [],
  productSalesChannelConfigList: [],
  controlProductMappingList: [],
  GETCONTROLPRODUCTBYNAME: [],
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case CREATEPRODUCTGROUP:
      return {
        ...state,
        productgroupSaveStatus: action.payload.success,
      };
    case GETPRODUCTGROUP:
      return {
        ...state,
        productgroupList: action.payload.data,
      };
    case UPDATEPRODUCTGROUP:
      return {
        ...state,
        productgroupUpdateStatus: action.payload.success,
      };

    case DELETEPRODUCTGROUP:
      return {
        ...state,
        productgroupList: state.productgroupList.filter(
          (item) => item.id !== action.productId,
        ),
        productgroupDeleteStatus: action.payload.success,
      };
    case CREATEPRODUCT:
      return {
        ...state,
        productSaveStatus: action.payload.success,
      };
    case GETPRODUCT:
      return {
        ...state,
        productList: action.payload.data,
      };
    case UPDATEPRODUCT:
      return {
        ...state,
        productUpdateStatus: action.payload.success,
      };

    case DELETEPRODUCT:
      return {
        ...state,
        productDeleteStatus: action.payload.success,
      };

    case CREATESPECIFICATION:
      return {
        ...state,
        SpecificationSaveStatus: action.payload.success,
      };
    case GETSPECIFICATION:
      return {
        ...state,
        SpecificationList: action.payload.data,
      };
    case UPDATESPECIFICATION:
      return {
        ...state,
        SpecificationUpdateStatus: action.payload.success,
      };

    case DELETESPECIFICATION:
      return {
        ...state,
        SpecificationList: state.SpecificationList.filter(
          (item) => item.id !== action.specificationId,
        ),
        SpecificationDeleteStatus: action.payload.success,
      };

    case CREATEPROMOCODE:
      return {
        ...state,
        PromocodeSaveStatus: action.payload.success,
      };
    case GETPROMOCODE:
      return {
        ...state,
        PromocodeList: action.payload.data,
      };
    case UPDATEPROMOCODE:
      return {
        ...state,
        PromocodeUpdateStatus: action.payload.success,
      };
    case DELETEPROMOCODE:
      return {
        ...state,
        PromocodeList: state.PromocodeList.filter(
          (item) => item.id !== action.promoId,
        ),
        PromocodeDeleteStatus: action.payload.success,
      };

    case CREATEPPRODUCTPACKAGE:
      return {
        ...state,
        ProductPackageSaveStatus: action.payload.success,
      };
    case GETPPRODUCTPACKAGE:
      console.log("Payload for Packages:", action.payload);

      return {
        ...state,
        ProductPackageList: action.payload.data,
      };
    case UPDATEPPRODUCTPACKAGE:
      return {
        ...state,
        ProductPackageUpdateStatus: action.payload.success,
      };

    case DELETEPPRODUCTPACKAGE:
      return {
        ...state,
        ProductPackageList: state.ProductPackageList.filter(
          (item) => item.id !== action.packageId,
        ),
        ProductPackageUpdateStatus: action.payload.success,
      };
    case CREATEPPRODUCTTAX:
      return {
        ...state,
        ProductTaxSaveStatus: action.payload.success,
      };
    case GETPPRODUCTTAX:
      return {
        ...state,
        ProductTaxList: action.payload.data,
      };
    case UPDATEPPRODUCTTAX:
      return {
        ...state,
        ProductTaxUpdateStatus: action.payload.success,
      };

    case DELETEPPRODUCTTAX:
      return {
        ...state,
        ProductTaxDeleteStatus: action.payload.success,
      };

    case GETPPRODUCTTAXTYPE:
      return {
        ...state,
        ProductTaxTypeList: action.payload.data,
      };
    case CREATEPPRODUCTTAXTYPE:
      return {
        ...state,
        ProductTaxTypeSaveStatus: action.payload.success,
      };
    case UPDATEPPRODUCTTAXTYPE:
      return {
        ...state,
        ProductTaxTypeUpdateStatus: action.payload.success,
      };
    case DELETEPPRODUCTTAXTYPE:
      return {
        ...state,
        ProductTaxTypeDeleteStatus: action.payload.success,
      };

    case VERIFY_AND_SAVE_PAYMENT:
      return {
        ...state,
        paymentVerificationStatus: action.payload.success,
      };

    case CREATESPECIFICATIONTYPE:
      return {
        ...state,
        SpecificationTypeSaveStatus: action.payload.success,
      };
    case GETSPECIFICATIONTYPE:
      return {
        ...state,
        SpecificationTypeList: action.payload.data,
      };
    case UPDATESPECIFICATIONTYPE:
      return {
        ...state,
        SpecificationTypeUpdateStatus: action.payload.success,
      };
    case DELETESPECIFICATIONTYPE:
      return {
        ...state,
        SpecificationTypeDeleteStatus: action.payload.success,
      };
    case GETTRANSACTIONINFORMATION:
      return {
        ...state,
        transactionList: action.payload.data,
      };

    case CREATESPECIALIZATION:
      return {
        ...state,
        SpecializationSaveStatus: action.payload.success,
      };
    case GETSPECIALIZATION:
      return {
        ...state,
        SpecializationList: action.payload.data,
      };
    case UPDATESPECIALIZATION:
      return {
        ...state,
        SpecializationUpdateStatus: action.payload.success,
      };
    case DELETESPECIALIZATION:
      return {
        ...state,
        SpecializationDeleteStatus: action.payload.success,
      };

    case CREATEPRODUCTSETUPDEPARTMENT:
      return {
        ...state,
        setupProductDepartmentSaveStatus: action.payload.success,
      };
    case GETPRODUCTSETUPDEPARTMENT:
      return {
        ...state,
        setupProductDepartmentList: action.payload.data,
      };
    case UPDATEPRODUCTSETUPDEPARTMENT:
      return {
        ...state,
        setupProductDepartmentUpdateStatus: action.payload.success,
      };
    case DELETEPRODUCTSETUPDEPARTMENT:
      return {
        ...state,
        setupProductDepartmentList: state.setupProductDepartmentList.filter(
          (item) => item.id !== action.departmentId,
        ),
        setupProductDepartmentDeleteStatus: action.payload.success,
      };

    case CREATEPRODUCTSETUPROLE:
      return {
        ...state,
        setupproductRoleSaveStatus: action.payload.success,
      };
    case GETPRODUCTSETUPROLE:
      return {
        ...state,
        setupproductRoleList: action.payload.data,
      };
    case UPDATEPRODUCTSETUPROLE:
      return {
        ...state,
        setupproductRoleUpdateStatus: action.payload.success,
      };
    case DELETEPRODUCTSETUPROLE:
      return {
        ...state,
        setupproductRoleList: state.setupproductRoleList.filter(
          (item) => item.id !== action.roleId,
        ),
        setupproductRoleDeleteStatus: action.payload.success,
      };

    case CREATEPRODUCTSETUPROLETYPE:
      return {
        ...state,
        setupproductRoleTypeSaveStatus: action.payload.success,
      };
    case GETPRODUCTSETUPROLETYPE:
      return {
        ...state,
        setupproductRoleTypeList: action.payload.data,
      };
    case UPDATEPRODUCTSETUPROLETYPE:
      return {
        ...state,
        setupproductRoleTypeUpdateStatus: action.payload.success,
      };
    case DELETEPRODUCTSETUPROLETYPE:
      return {
        ...state,
        setupproductRoleTypeDeleteStatus: action.payload.success,
      };
    case CREATEDURATION:
      return {
        ...state,
        setupProductDurationListSaveStatus: action.payload.success,
      };
    case GETDURATION:
      return {
        ...state,
        setupProductDurationList: action.payload.data,
      };
    case UPDATEDURATION:
      return {
        ...state,
        setupProductDurationListUpdateStatus: action.payload.success,
      };
    case DELETEDURATION:
      return {
        ...state,
        setupProductDurationList: state.setupProductDurationList.filter(
          (item) => item.id !== action.durationId,
        ),
        setupProductDurationListDeleteStatus: action.payload.success,
      };

    case CREATEPAYMENTMODE:
      return {
        ...state,
        paymentmodelistSaveStatus: action.payload.success,
      };
    case GETPAYMENTMODE:
      return {
        ...state,
        paymentModeList: action.payload.data,
      };
    case UPDATEPAYMENTMODE:
      return {
        ...state,
        paymentmodelistUpdateStatus: action.payload.success,
      };
    case DELETEPAYMENTMODE:
      return {
        ...state,
        paymentModeList: state.paymentModeList.filter(
          (item) => item.id !== action.paymentModeId,
        ),
        paymentmodelistDeleteStatus: action.payload.success,
      };
    case CREATEPRODUCTSPECIALITY:
      return {
        ...state,
        specialitySaveStatus: action.payload.success,
      };

    case GETPRODUCTSPECIALITY:
      return {
        ...state,
        allspecialityList: action.payload.data,
      };

    case UPDATEPRODUCTSPECIALITY:
      return {
        ...state,
        specialityUpdateStatus: action.payload.success,
      };

    case DELETEPRODUCTSPECIALITY:
      return {
        ...state,
        allspecialityList: state.allspecialityList.filter(
          (item) => item.id !== action.specialityId,
        ),
        specialityDeleteStatus: action.payload.success,
      };
    case CREATEPRODUCTLANGUAGE:
      return { ...state, productLanguageSaveStatus: action.payload.success };
    case GETPRODUCTLANGUAGE:
      return { ...state, productLanguageList: action.payload.data };
    case UPDATEPRODUCTLANGUAGE:
      return { ...state, productLanguageUpdateStatus: action.payload.success };
    case DELETEPRODUCTLANGUAGE:
      return {
        ...state,
        productLanguageList: state.productLanguageList.filter(
          (item) => item.id !== action.languageId,
        ),
        productLanguageDeleteStatus: action.payload.success,
      };

    case CREATEPRODUCTCURRENCY:
      return { ...state, productCurrencySaveStatus: action.payload.success };
    case GETPRODUCTCURRENCY:
      return { ...state, productCurrencyList: action.payload.data };
    case UPDATEPRODUCTCURRENCY:
      return { ...state, productCurrencyUpdateStatus: action.payload.success };
    case DELETEPRODUCTCURRENCY:
      return {
        ...state,
        productCurrencyList: state.productCurrencyList.filter(
          (item) => item.id !== action.currencyId,
        ),
        productCurrencyDeleteStatus: action.payload.success,
      }

    case GETTAXRETURNTYPEMASTER:
      return {
        ...state,
        TaxReturnTypeMasterList: action.payload.data,
      };
    case CREATETAXRETURNTYPEMASTER:
      return {
        ...state,
        TaxReturnTypeMasterSaveStatus: action.payload.success,
      };
    case UPDATETAXRETURNTYPEMASTER:
      return {
        ...state,
        TaxReturnTypeMasterUpdateStatus: action.payload.success,
      };
    case DELETETAXRETURNTYPEMASTER:
      return {
        ...state,
        TaxReturnTypeMasterDeleteStatus: action.payload.success,
      };

    case GETTAXTDSSECTIONMASTER:
      return {
        ...state,
        TaxTDSSectionMasterList: action.payload.data,
      };
    case CREATETAXTDSSECTIONMASTER:
      return {
        ...state,
        TaxTDSSectionMasterSaveStatus: action.payload.success,
      };
    case UPDATETAXTDSSECTIONMASTER:
      return {
        ...state,
        TaxTDSSectionMasterUpdateStatus: action.payload.success,
      };
    case DELETETAXTDSSECTIONMASTER:
      return {
        ...state,
        TaxTDSSectionMasterDeleteStatus: action.payload.success,
      };

    case GETTAXTCSSECTIONMASTER:
      return {
        ...state,
        TaxTCSSectionMasterList: action.payload.data,
      };
    case CREATETAXTCSSECTIONMASTER:
      return {
        ...state,
        TaxTCSSectionMasterSaveStatus: action.payload.success,
      };
    case UPDATETAXTCSSECTIONMASTER:
      return {
        ...state,
        TaxTCSSectionMasterUpdateStatus: action.payload.success,
      };
    case DELETETAXTCSSECTIONMASTER:
      return {
        ...state,
        TaxTCSSectionMasterDeleteStatus: action.payload.success,
      };

    case GETTAXMASTER:
      return {
        ...state,
        TaxMasterList: action.payload.data,
      };
    case CREATETAXMASTER:
      return {
        ...state,
        TaxMasterSaveStatus: action.payload.success,
      };
    case UPDATETAXMASTER:
      return {
        ...state,
        TaxMasterUpdateStatus: action.payload.success,
      };
    case DELETETAXMASTER:
      return {
        ...state,
        TaxMasterDeleteStatus: action.payload.success,
      };



    default:
      return state;
  }
}
